export const SET_FORECAST = 'SET_FORECAST';

export const setForecast = (forecast) => ({
  type: SET_FORECAST,
  payload: forecast,
});
